import PieChartIcon from '@mui/icons-material/PieChart';
import { useTranslation } from 'react-i18next';

import { Container, DecoratedHeader } from '../../../components';
import { Tab } from '../../../navigation';
import NeedsPermission from '../../../security/NeedsPermission';
import { UserPermission } from '../../../enums';

interface Props {
  children: React.ReactNode;
}

const Reports = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <DecoratedHeader
          icon={<PieChartIcon />}
          title={t('reports.title')}
          variant="colored"
        >
          <NeedsPermission
            oneOf={[
              UserPermission.ViewReservationConversionRatesReports,
              UserPermission.ViewQuoteReports,
            ]}
          >
            <Tab
              title={t('reports.reservationConversionRate.title')}
              to="/corporate-user/reports/conversion-rate"
              match="/corporate-user/reports/conversion-rate/*"
            />
          </NeedsPermission>
        </DecoratedHeader>
      </Container>
      {children}
    </>
  );
};

export default Reports;
